import React, { useState } from "react";
import "./StaffAugmentationPage.css";
import BannerImage from "../../../assets/other_image/staf_agumentation_banners.jpg";
import StaffAugmentationOverview from "./StaffAugmentationOverview";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import BookDemoSection from "../PolarianALMSolution/BookDemoSection";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const faqData = [
  {
    question: "What is Staff Augmentation?",
    answer:
      "Staff Augmentation is a workforce strategy where organizations hire external technical experts on a flexible contract basis to supplement their in-house teams."
  },
  {
    question: "How is Nextech PLM's Staff Augmentation different from traditional staffing?",
    answer:
      "Unlike generic staffing agencies, Nextech PLM specializes in PLM Tech talent and provides continuous training & support, ensuring higher productivity and alignment with your goals."
  },
  {
    question: "What types of engagement models does Nextech PLM offer?",
    answer:
      "We offer Contract Staff, Contract-to-Hire, and Staffing Services, giving businesses the flexibility to scale as needed."
  },
  {
    question: "How does Nextech PLM ensure resource quality?",
    answer:
      "All candidates undergo primary screening by Nextech technocrats. Clients retain final evaluation rights to ensure the best fit."
  },
  {
    question: "Which industries benefit most from Nextech PLM Staff Augmentation?",
    answer:
      "Our services are ideal for automotive, aerospace, medical devices, electronics, and other PLM-driven industries."
  },
  {
    question: "Can Nextech PLM support long-term contracts?",
    answer:
      "Yes. We provide both short-term and long-term contracts, as well as the option to transition contract staff into permanent roles."
  }
];

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item">
      <button
        className="faq-question"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span>{question}</span>
        <span>{open ? "−" : "+"}</span>
      </button>
      {open && <div className="faq-answer">{answer}</div>}
    </div>
  );
};

const SectionHeader = ({ title, subtitle }) => (
  <header className="section-header">
    <h2 className="section-title">{title}</h2>
    {subtitle && <p className="section-subtitle">{subtitle}</p>}
  </header>
);

const TileGrid = ({ items }) => (
  <div className="tile-grid-3x2">
    {items.map((item, index) => (
      <article className="feature-tile" key={index}>
        {item.icon && (
          <div className="tile-icon">
            <img src={item.icon} alt={item.title} width="48" height="48" />
          </div>
        )}
        <h3 className="tile-title">{item.title}</h3>
        <p className="tile-content">{item.content}</p>
      </article>
    ))}
  </div>
);

const StaffAugmentationPage = () => {
  const whyNextechItems = [
    {
      icon: "https://img.icons8.com/fluency/48/brain.png",
      title: "Specialized PLM Talent Pool",
      content:
        "Deep expertise in Product Lifecycle Management (PLM) and niche technical domains."
    },
    {
      icon: "https://img.icons8.com/fluency/48/lightning-bolt.png",
      title: "Fast & Flexible Scaling",
      content:
        "Ramp up or down quickly to match project and market needs."
    },
    {
      icon: "https://img.icons8.com/fluency/48/settings.png",
      title: "Structured Staffing Processes",
      content:
        "Proven methodologies for efficient hiring and onboarding."
    },
  {
  icon: "https://img.icons8.com/color/48/security-checked.png", 
  title: "Reduced Hiring Risk",
  content: "Nextech pre-screens candidates, clients make the final call."
},
    {
      icon: "https://img.icons8.com/fluency/48/training.png",
      title: "Continuous Enablement",
      content:
        "Ongoing training ensures resources evolve with project demands."
    },
   {
  icon: "https://img.icons8.com/color/48/handshake.png",
  title: "Strategic Workforce Partner",
  content: "Not just filling roles — we align staffing with your long-term business goals."
}
  ];

  const featuredSolutionsItems = [
    {
      icon: "https://img.icons8.com/fluency/48/search.png",
      title: "Talent Identification & Pre-Screening",
      content:
        "Access rigorously vetted PLM Tech professionals, pre-screened by our in-house experts for technical and domain excellence."
    },
    {
      icon: "https://img.icons8.com/color/48/time.png", // ✅ FIXED ICON
      title: "Flexible Engagement Models",
      content:
        "Select from Contract Staff, Contract-to-Hire, or Staffing Services, enabling maximum agility and control."
    },
    {
      icon: "https://img.icons8.com/fluency/48/teamwork.png",
      title: "Seamless Team Integration",
      content:
        "Ensure smooth onboarding of external talent into your in-house functional teams with minimal ramp-up time."
    },
    {
      icon: "https://img.icons8.com/fluency/48/learning.png",
      title: "Continuous Learning & Competency Support",
      content:
        "Our in-house competency center provides ongoing training, mentoring, and knowledge transfer to boost performance."
    },
    {
      icon: "https://img.icons8.com/fluency/48/approval.png",
      title: "Customer-Driven Final Evaluation",
      content:
        "Maintain hiring control with the ability to conduct the final evaluation and selection of resources."
    },
    {
      icon: "https://img.icons8.com/color/48/factory.png",
      title: "Industry-Wide Expertise",
      content:
        "Leverage specialized PLM Tech talent across industries such as automotive, aerospace, medical devices, and electronics."
    }
  ];

  const ourSolutionsItems = [
  {
    icon: "https://img.icons8.com/fluency/48/consultation.png",
    title: "On-Demand PLM Experts",
    content: "Quickly onboard specialized PLM tech experts to your projects."
  },
  {
    icon: "https://img.icons8.com/fluency/48/contract.png",
    title: "Flexible Engagements",
    content: "Contract, contract-to-hire, or long-term staffing aligned to your needs."
  },
  {
    icon: "https://img.icons8.com/color/48/enter-2.png", // ⭐ FIXED
    title: "Smooth Onboarding",
    content: "Minimal disruption and fast integration with your internal teams."
  },
  {
    icon: "https://img.icons8.com/fluency/48/knowledge-sharing.png",
    title: "Training & Knowledge Transfer",
    content: "Practical enablement through our competency center and mentorship."
  },
  {
    icon: "https://img.icons8.com/color/48/approval.png", // ⭐ FIXED
    title: "Rigorous Screening",
    content: "Technical-first screening done by Nextech technocrats to ensure quality."
  },
  {
    icon: "https://img.icons8.com/fluency/48/support.png",
    title: "Managed Workforce Support",
    content: "Ongoing support, upskilling and performance oversight."
  }
];


  return (
    <>
      <Helmet>
        <title>Teamcenter Staff Augmentation Services in Pune | Nextech PLM</title>
        <meta name="description" content="Scale your PLM team with expert staff augmentation services in Pune, India. Nextech PLM provides skilled professionals for your projects." />
        <meta name="keywords" content="PLM staff augmentation Pune, Teamcenter consultants India, PLM resource outsourcing, Teamcenter staffing services, PLM talent solutions" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <link rel="canonical" href="https://nextechplm.com/teamcenter-staff-augmentation-services" />
        <meta property="og:site_name" content="NexTech PLM Solutions" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Teamcenter Staff Augmentation Services in Pune | Nextech PLM" />
        <meta property="og:description" content="Scale your PLM team with expert staff augmentation services in Pune, India. Nextech PLM provides skilled professionals for your projects." />
        <meta property="og:url" content="https://nextechplm.com/teamcenter-staff-augmentation-services" />
        <meta name="twitter:title" content="Teamcenter Staff Augmentation Services in Pune | Nextech PLM" />
        <meta name="twitter:description" content="Scale your PLM team with expert staff augmentation services in Pune, India. Nextech PLM provides skilled professionals for your projects." />
      </Helmet>

      <main className="polarion-solution-page">
        <Banner image={BannerImage} heading="Staff Augmentation meaning" />
        <FloatingContactUs />
        <StaffAugmentationOverview />

        <section className="section benefits-section">
          <div className="container">
            <div className="row g-4 align-items-center">
              <div className="col-md-6 col-12">
                <div className="benefits-card">
                  <h3 className="benefits-heading">
                    Benefits of NextTech Teamcenter AMC
                  </h3>
                  <ul className="benefits-list">
                    <li><span className="benefit-icon">✔</span> Global Expertise: Proven PLM support service across industries worldwide.</li>
                    <li><span className="benefit-icon">✔</span> Dedicated Experts: Skilled PLM professionals committed to excellence.</li>
                    <li><span className="benefit-icon">✔</span> Data Security: Absolute assurance of data privacy with trusted PLM experts.</li>
                    <li><span className="benefit-icon">✔</span> Mission-Critical Specialization: Tailored support for complex PLM environments.</li>
                    <li><span className="benefit-icon">✔</span> Cost-Optimized Models: Flexible onsite, offsite, or hybrid support models.</li>
                    <li><span className="benefit-icon">✔</span> Business Alignment: Maximize Teamcenter usage to meet strategic goals.</li>
                  </ul>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="quick-links">
                  <h4>Quick Links</h4>
                  <ul>
                    <li><NavLink to="/teamcenter/plm-document-management">Document Management</NavLink></li>
                    <li><NavLink to="/teamcenter/manufacturing-data-process-management">Manufacturing Data and Process Management</NavLink></li>
                    <li><NavLink to="/teamcenter/product-bom-variability-management">Product BOM and Variability Management</NavLink></li>
                    <li><NavLink to="/teamcenter/community-collaboration">Teamcenter Community Collaboration</NavLink></li>
                    <li><NavLink to="/teamcenter/cloud-implementation">Teamcenter Implementation on Cloud</NavLink></li>
                    <li><NavLink to="/teamcenter/ecad-integration">ECAD Integration</NavLink></li>
                    <li><NavLink to="/teamcenter/mcad-integration">MCAD Integration</NavLink></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <BookDemoSection />

        <section className="section featured-solutions-section">
          <div className="container">
            <SectionHeader
              title="Featured Solutions"
              subtitle="Explore NexTech PLM's Staff Augmentation Capabilities — Flexible, Scalable, and Designed for Impact."
            />
            <TileGrid items={featuredSolutionsItems} />
          </div>
        </section>

        <section className="section our-solutions-section">
          <div className="container">
            <SectionHeader title="Our Solutions" />
            <p className="section-intro">
              At <strong>NexTech PLM</strong>, we deliver end-to-end Staff Augmentation solutions that go beyond simple placement — seamlessly integrating talent with your teams and processes.
            </p>
            <TileGrid items={ourSolutionsItems} />
            <p className="section-outro">
              With our experienced recruitment, competency center, and managed support, <span className="highlight">Nextech PLM helps you build the right team fast</span>.
            </p>
          </div>
        </section>

        <section className="section why-nextech-section">
          <div className="container">
            <SectionHeader title="Why Choose NexTech PLM for Staff Augmentation?" />
            <p className="section-intro">
              More than staffing — we deliver workforce agility, technical expertise, and long-term value.
            </p>
            <TileGrid items={whyNextechItems} />
            <p className="section-outro">
              With our proven track record and certified PLM experts, NexTech ensures your staffing investment consistently drives business outcomes.
            </p>
          </div>
        </section>

        <section className="section faq-section">
          <div className="container">
            <SectionHeader title="Staff Augmentation FAQs" />
            <div className="faq-container">
              {faqData.map((item, i) => (
                <FAQItem key={i} question={item.question} answer={item.answer} />
              ))}
            </div>
          </div>
        </section>

        <Letsgetintouch />
      </main>
    </>
  );
};

export default StaffAugmentationPage;
